var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArsLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    id: "svg14",
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:#fff;}.cls-2{fill:#fff;}.cls-3{fill:#69a0b3;}.cls-4{fill:#b1cfd8;}.cls-5{fill:#7ba9b7;}.cls-6{fill:#558a9c;}.cls-7{fill:#4f7742;}.cls-8{fill:#486623;}.cls-9{fill:#ebe08b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      color: "#000000",
      fill: "#ffffff",
      InkscapeStroke: "none"
    },
    d: "m 64,16 c -20.875798,0 -38,16.547395 -38,37 0,3.612548 0.544265,7.099228 1.539062,10.398438 l 6.509766,-8.783204 C 34.018596,54.080137 34,53.542375 34,53 34,37.00192 47.320548,24 64,24 c 16.679452,0 30,13.00192 30,29 0,0.448833 -0.01441,0.893995 -0.03516,1.337891 l 6.55664,8.853515 C 101.47674,59.953147 102,56.537288 102,53 102,32.547395 84.875798,16 64,16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 7.9405082,103.28035 40.7323898,-54.962412 6.594563,5.070348 8.849756,-16.802986 8.849755,16.810764 6.594564,-5.064553 40.732384,54.998209 -21.06627,-0.009 -70.220876,-0.0308 z",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 29.006774,103.2896 99.22765,103.32047 84.959032,76.18963 75.393173,94.149997 64.117217,60.206323 52.830572,94.160392 43.28609,76.171318 Z",
    id: "path1"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArsLogoWhite);
export default __webpack_public_path__ + "static/media/ars-logo-white.71f5c573cf63167e5961c82499b587e1.svg";
export { ForwardRef as ReactComponent };